export function getCrumbsList() {
  let name = '';
  let crumbsList = [];
  $.each($("body .el-menu--horizontal").find(".is-active"), function(i, n){
    if($(this).children(".el-submenu__title").length > 0){
      name = $(this).children(".el-submenu__title").text();
    }else{
      name = $(this).text();
    }
    crumbsList.push(name);
  });
  return crumbsList;
}
